

















































































































































































import { ValidationObserver, ValidationProvider } from "vee-validate";
import { Component, Prop, Ref, Vue } from "vue-property-decorator";
import { DataTableHeader } from "vuetify";
import { ACTION } from ".";
import { deepCopy } from "deep-copy-ts";
import {
  ControllerModel,
  LocationsApi,
  UnitsApi,
  VariableModel,
  VariablesApi,
} from "../../../apis";
import { cond } from "lodash";

@Component({
  components: { ValidationProvider, ValidationObserver },
})
export default class VariableUnitDialog extends Vue {
  @Prop({ default: false }) value: Boolean;
  @Prop({ default: "" }) title: string;
  @Ref("observer") readonly observer!: InstanceType<typeof ValidationObserver>;

  searchFormSource = {
    plcId: "",
    ipAddress: "",
    type: "",
    keyword: "",
  };
  searchFormTarget = {
    plcId: "",
    ipAddress: "",
    type: "",
    keyword: "",
  };
  selectedVariables: VariableModel[] = [];
  selectedVariablesTarget: VariableModel[] = [];
  variablesSource: VariableModel[] = [];
  variablesTarget: VariableModel[] = [];
  variablesTargetOriginal: VariableModel[] = [];
  plcs: ControllerModel[] = [];

  get show() {
    this.searchFormSource = {
      plcId: "",
      ipAddress: "",
      type: "",
      keyword: "",
    };
    this.searchFormTarget = {
      plcId: "",
      ipAddress: "",
      type: "",
      keyword: "",
    };
    this.selectedVariables = [];
    this.selectedVariablesTarget = [];
    this.variablesTarget = [];
    this.variablesSource = [];
    return this.value;
  }

  set show(value) {
    if (this.observer) this.observer.reset();
    this.$emit("input", value);
  }

  get PLCS() {
    return this.plcs.map((val) => ({
      text: val.ipAddress + " - " + val.name,
      value: val.id,
    }));
  }

  get TYPES() {
    return [
      { text: "Bool", value: "BOOL" },
      { text: "Byte", value: "BYTE" },
      { text: "UByte", value: "UBYTE" },
      { text: "Word", value: "WORD" },
      { text: "Floating", value: "FLOATING" },
      { text: "Time", value: "TIME" },
    ];
  }

  get HEADERS() {
    return [
      {
        text: this.$t("text.ipAddress"),
        value: "ipAddress",
        class: ["tw-pl-0", "tw-whitespace-no-wrap"],
        cellClass: ["tw-pl-0"],
        // width: 150,
      },
      {
        text: this.$t("text.controller"),
        value: "controller",
        class: ["tw-whitespace-no-wrap"],
        // width: "130"
      },
      {
        text: this.$t("text.controllerVariableName"),
        value: "variableName",
        class: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.controllerVariableMemory"),
        value: "memory",
        class: ["tw-whitespace-no-wrap"],
      },
    ] as DataTableHeader[];
  }

  async onSubmit() {
    this.$util.showLoading();
    try {
      await new UnitsApi().createUnitVariable({
        id: this.$route.params.unitId,
        putAssignVariableRequest: {
          variables: this.variablesTarget.filter((val)=> this.selectedVariablesTarget.find((s)=> s.id == val.id)).map((val) => val.id),
        },
      });
      this.show = false;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  async onShow() {
    await this.getPlcs();
    await this.getUnassignedVariables();
    // await Promise.all([this.getPlcs(), this.getUnassignedVariables()]);
  }

  moveToRight() {
    this.variablesTarget = this.variablesTarget.concat(
      deepCopy(this.selectedVariables)
    );
    this.variablesTargetOriginal = deepCopy(this.variablesTarget);
    this.selectedVariablesTarget = deepCopy(this.selectedVariables);
    const ids = this.selectedVariables.map((val) => val.id);
    this.variablesSource = deepCopy(
      this.variablesSource.filter((item) => !ids.includes(item.id))
    );
    this.selectedVariables = [];
  }
  moveAllToRight() {
    if (this.lodash.isEmpty(this.variablesSource)) {
      return;
    }
    this.variablesTarget = deepCopy(this.variablesSource);
    this.variablesTargetOriginal = deepCopy(this.variablesTarget);
    this.selectedVariablesTarget = deepCopy(this.variablesSource);
    this.variablesSource = [];
    this.selectedVariables = [];
  }
  moveToLeft() {
    const ids = this.selectedVariablesTarget.map((val) => val.id);
    this.selectedVariablesTarget = this.variablesTarget.filter(
      (item) => !ids.includes(item.id)
    );
    this.variablesTarget = this.variablesTarget.filter(
      (item) => !ids.includes(item.id)
    );
    this.variablesTargetOriginal = deepCopy(this.variablesTarget);
    this.getUnassignedVariables();
  }

  moveAllToLeft() {
    this.variablesTarget = [];
    this.variablesTargetOriginal = [];
    this.selectedVariablesTarget = [];
    this.getUnassignedVariables();
  }

  async getPlcs() {
    this.plcs = (
      await new LocationsApi().getControllersByLocationId({
        id: this.$route.params.id,
      })
    ).data.data;
  }

  async getUnassignedVariables() {
    this.$util.showLoading();
    try {
      const rs = await new VariablesApi().getUnassignedVariables({
        keyword: this.searchFormSource.keyword || "",
        type: this.searchFormSource.type || "",
        controllerId: this.searchFormSource.plcId || "",
        locationId: this.$route.params.id,
      });
      let items = rs.data.data;
      this.selectedVariables = [];
      const ids = this.selectedVariablesTarget.map((val) => val.id);
      items = items.filter((item) => !ids.includes(item.id));
      this.variablesSource = deepCopy(items);
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  doSearchTarget() {
    let condition = {} as { [k: string]: string };
    if (this.searchFormTarget.plcId) {
      condition.controllerId = this.searchFormTarget.plcId;
    }
    if (this.searchFormTarget.type) {
      condition.type = this.searchFormTarget.type;
    }
    if (this.searchFormTarget.keyword) {
      condition.variableName = this.searchFormTarget.keyword;
    }
    this.variablesTarget = this.lodash.filter(
      this.variablesTargetOriginal,
      (item) => {
        let result = true;
        for (const [k, v] of Object.entries(condition)) {
          if (k === "variableName") {
            const name = item.variableName.toLowerCase();
            const otherName = v.trim().toLowerCase();
            result =
              result &&
              (name.includes(otherName) ||
                item.memory.toLowerCase().includes(otherName));
          } else result = result && item[k] === v;
        }
        return result;
      }
    );
  }
}
